const { isNil } = require('lodash');
const { DEFAULT_CHEVRON_PROPS } = require('../../../../../Shape/config/Shapes');

const isFull = shape => (isNil(shape.get('isFull')) ? DEFAULT_CHEVRON_PROPS.isFull : shape.get('isFull'));

export default isFull;
